import styled, { css } from "styled-components";

export const Flex = styled.div`
  display: flex;
  justify-content: flex-start;
  align-items: center;
  gap: 14px;
`